import {
  ApiError,
  AuthenticationError,
  ForbiddenError,
  NotFoundError,
  SemanticError,
  ServerError,
  SyntacticError,
} from './errors';

/**
 * Map exceptions in response according to status code to the right Error class
 * @param {Response} response to extract the exception information from
 */
export async function errorMapper(response: Response) {
  // Errors need to be constructed asynchronously, so we need a Factory-Function
  switch (response.status) {
    case 400: {
      return SyntacticError.create(response);
    }
    case 401: {
      return AuthenticationError.create(response);
    }
    case 403: {
      return ForbiddenError.create(response);
    }
    case 404: {
      return NotFoundError.create(response);
    }
    case 422: {
      return SemanticError.create(response);
    }
    case 500: // Internal Server Error
    case 502: // Bad Gateway
    case 503: // Service Unavailable
    case 504: {
      // Gateway Timeout
      return ServerError.create(response);
    }
    default: {
      return ApiError.create(response);
    }
  }
}
